<template>
  <div class="mx-auto max-w-lg space-y-4">
    <p class="text-center font-semibold">
      {{ $t('embed_code_heading') }}
    </p>
    <input
      type="text"
      :value="embedCode"
      class="w-full rounded-md border px-4 py-3"
      readonly
    />
    <ShareCopyButton
      :source="embedCode"
      :label="$t('copy_embed_code')"
      full-width
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  embedCode: string
}>()
</script>
